import { observer } from 'mobx-react-lite'
import { type ProSoftwareReviewModalViewModel } from './ProSoftwareReviewModalViewModel'
import { ProSoftwareReviewModal } from '@/features/iam/providers/ProSoftwareReviewModal'

export interface ProSoftwareReviewModalContainerProps {
  vm: ProSoftwareReviewModalViewModel
}

const noop = () => undefined

export const ProSoftwareReviewModalContainer = observer(
  function ProSoftwareReviewModalContainer({
    vm,
  }: ProSoftwareReviewModalContainerProps) {
    const details = vm.details
    return (
      <ProSoftwareReviewModal
        showing={vm.modal.showing}
        hasDetails={Boolean(details)}
        softwareOwned={details ? details.softwareOwned.slice() : []}
        onSoftwareOwnedChange={details ? details.setSoftwareOwned : noop}
        onConfirm={vm.confirm}
        isConfirmPending={vm.confirm.pending}
      />
    )
  },
)
